import { render, staticRenderFns } from "./ManageSystems.vue?vue&type=template&id=99c44886&scoped=true&"
import script from "./ManageSystems.vue?vue&type=script&lang=ts&"
export * from "./ManageSystems.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSystems.vue?vue&type=style&index=0&id=99c44886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c44886",
  null
  
)

export default component.exports